<template>
  <div @click="toggleMenu">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    toggleMenu() {
      if (this.$store.state.headerStatus !== 'basic') {
        this.$store.commit('setHeaderStatus', 'basic');
      }
    }
  },
  mounted() {},
  beforeDestroy() {}
};
</script>
